import { render, staticRenderFns } from "./VehicleStateChip.vue?vue&type=template&id=4f931eec"
import script from "./VehicleStateChip.vue?vue&type=script&lang=ts"
export * from "./VehicleStateChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports